import {isCopilot} from './copilot-user'
import {CopilotAvatar} from '@github-ui/copilot-avatar'
import {GitHubAvatar} from '@github-ui/github-avatar'

import styles from './AssigneeVisual.module.css'

export type AssigneeVisualProps = {login: string; id: string; avatarUrl: string}

export function AssigneeVisual({login, id, avatarUrl}: AssigneeVisualProps) {
  if (isCopilot(login)) {
    return <CopilotAvatar />
  } else {
    return <GitHubAvatar src={avatarUrl} size={20} alt={`@${login}`} key={id} className={styles.GitHubAvatar} />
  }
}

try{ AssigneeVisual.displayName ||= 'AssigneeVisual' } catch {}